import { WEBHOOK_EVENT_TYPES } from '../webhook-event-types.js';
import { getUserAndEventTime } from './lib/index.js';
export const createPayrollRunsUpdatedSamplePayload = () => {
    return {
        eventType: WEBHOOK_EVENT_TYPES.PAYROLL_RUNS_UPDATED,
        ...getUserAndEventTime(),
        data: {
            uri: 'https://api.atomicfi.com/employers/642c9aa6f8fc90e0dbb4c92f/payroll-runs',
            employerId: '642c9aa6f8fc90e0dbb4c92f',
            payrollRuns: [{ _id: '6488cb8e98c1ac681cd635f8' }]
        }
    };
};
//# sourceMappingURL=payroll-runs-updated.js.map